import { Clock, MapPin, MessageCircle, Navigation, Phone } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import MapEmbed from "../components/MapEmbed";
import { STORES, mapsLink, waLink } from "../data/siteData";

export default function Contatti() {
  return (
    <>
      <SEO
        title="Contatti | Sisal Store Mestre, Padova, Sant'Angelo di Piove di Sacco"
        description="Contatta il Sisal Store più vicino: indirizzi, telefoni, WhatsApp, orari e indicazioni stradali delle sedi di Mestre, Padova e Sant'Angelo di Piove di Sacco."
      />
      <section data-testid="contatti-page" className="py-16 sm:py-24">
        <div className="container-x">
          <Reveal>
            <p className="overline-tag">Contatti</p>
            <h1 className="mt-3 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Scegli il punto vendita
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">
              Tre sedi sul territorio, sempre pronte ad aiutarti. Chiamaci, scrivici su WhatsApp o
              vieni a trovarci.
            </p>
          </Reveal>

          <div className="mt-12 space-y-8">
            {STORES.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.06}>
                <article
                  data-testid={`contact-store-${s.id}`}
                  className="card-soft grid gap-8 overflow-hidden p-6 sm:p-8 lg:grid-cols-2"
                >
                  <div>
                    <p className="overline-tag">{String(i + 1).padStart(2, "0")} — {s.city}</p>
                    <h2 className="mt-2 font-display text-xl font-extrabold uppercase tracking-tight text-ink sm:text-2xl">
                      {s.name}
                    </h2>

                    <div className="mt-6 space-y-4 text-sm">
                      <p className="flex items-start gap-3 text-slate-600">
                        <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand" />
                        {s.fullAddress}
                      </p>
                      <p className="flex items-start gap-3 text-slate-600">
                        <Clock className="mt-0.5 h-5 w-5 shrink-0 text-brand" />
                        {s.hoursSummary}
                      </p>
                      <p className="flex items-start gap-3 text-slate-600">
                        <Phone className="mt-0.5 h-5 w-5 shrink-0 text-brand" />
                        {s.phoneDisplay}
                      </p>
                      <p className="flex items-start gap-3 text-slate-600">
                        <MessageCircle className="mt-0.5 h-5 w-5 shrink-0 text-brand" />
                        {s.whatsappDisplay
                          ? `WhatsApp: ${s.whatsappDisplay}`
                          : "WhatsApp: prossimamente disponibile"}
                      </p>
                    </div>

                    <div className="mt-7 flex flex-col gap-2.5 sm:flex-row sm:flex-wrap">
                      <a href={`tel:${s.phoneTel}`} data-testid={`contact-call-${s.id}`} className="btn btn-primary btn-md">
                        <Phone className="h-4 w-4" />
                        CHIAMA
                      </a>
                      <a
                        href={mapsLink(s.fullAddress)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`contact-directions-${s.id}`}
                        className="btn btn-outline btn-md"
                      >
                        <Navigation className="h-4 w-4" />
                        INDICAZIONI STRADALI
                      </a>
                      {s.whatsapp && (
                        <a
                          href={waLink(s.whatsapp, `Ciao, vi contatto per la sede di ${s.shortName}.`)}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid={`contact-whatsapp-${s.id}`}
                          className="btn btn-outline btn-md"
                        >
                          <MessageCircle className="h-4 w-4" />
                          WHATSAPP
                        </a>
                      )}
                    </div>
                  </div>

                  <MapEmbed query={s.mapQuery} label={`contatti-${s.id}`} />
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
